import { PRODUCT_NAME } from "@src/shared/brand";

export interface UnauthenticatedLayoutV2Props {
  children: React.ReactNode;
}

export function UnauthenticatedLayoutV2({
  children,
}: UnauthenticatedLayoutV2Props) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="flex h-11 items-center border-b border-border px-5">
        <div className="inline-flex items-center gap-2">
          <span className="size-2 rounded-full bg-primary" aria-hidden="true" />
          <span className="font-mono text-[11px] font-semibold tracking-[0.08em] text-foreground">
            {PRODUCT_NAME.singular}
          </span>
        </div>
      </header>
      <div className="flex min-h-[calc(100vh-2.75rem)] items-center justify-center px-6 py-10">
        {children}
      </div>
    </div>
  );
}
